/* Submit through the existing form to preserve variant, quantity and cart behavior. */
if (!customElements.get('bluen-sticky-cart')) {
  customElements.define('bluen-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById(`ProductSection-${this.dataset.sectionId}`);
      this.mainButton = document.getElementById(`AddToCart-${this.dataset.sectionId}`);
      this.button = this.querySelector('[data-sticky-submit]');
      if (!this.section || !this.mainButton?.form || !this.button) return;

      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.sync();
        });
      };
      this.onClick = (event) => {
        if (!event.target.closest('[data-sticky-submit]')) return;
        event.preventDefault();
        if (this.mainButton.disabled || this.mainButton.classList.contains('is-loading')) return;
        this.mainButton.click();
        this.sync();
      };
      this.onChange = (event) => {
        const select = event.target.closest('[data-sticky-option]');
        if (select) {
          const controls = this.optionControls(select.dataset.stickyOption);
          const control = controls.find((item) => item.tagName === 'SELECT' || item.value === select.value);
          if (control && !control.disabled) {
            if (control.tagName === 'SELECT') {
              control.value = select.value;
              control.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              control.click();
            }
          }
        }
        this.schedule();
      };
      this.addEventListener('click', this.onClick);
      this.section.addEventListener('change', this.onChange);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      window.addEventListener('pageshow', this.schedule);
      this.intersection = new IntersectionObserver(this.schedule, { threshold: [0, 1] });
      this.intersection.observe(this.mainButton);
      this.mutations = new MutationObserver(this.schedule);
      this.mutations.observe(this.mainButton, { attributes: true, childList: true, characterData: true, subtree: true });
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this);
      this.resize.observe(this.mainButton);
      this.sync();
    }

    optionControls(index) {
      return Array.from(this.mainButton.form.querySelectorAll(`[data-index="option${index}"]`));
    }

    sync() {
      const rect = this.mainButton.getBoundingClientRect();
      const rendered = rect.width > 0 && rect.height > 0;
      const inView = rect.bottom > 0 && rect.top < window.innerHeight &&
        rect.right > 0 && rect.left < window.innerWidth;
      const visible = rendered && !inView;
      this.classList.toggle('active', visible);
      this.inert = !visible;
      this.setAttribute('aria-hidden', String(!visible));
      const bottomOffset = parseFloat(window.getComputedStyle(this).bottom) || 0;
      document.documentElement.style.setProperty('--height-sticky', rendered ? `${this.offsetHeight + bottomOffset}px` : '0px');

      const loading = this.mainButton.classList.contains('is-loading');
      this.button.disabled = this.mainButton.disabled || loading;
      this.button.setAttribute('aria-busy', String(loading));
      const text = document.getElementById(`AddToCartText-${this.dataset.sectionId}`)?.textContent.trim();
      if (text && this.button.textContent !== text) this.button.textContent = text;
      this.querySelectorAll('[data-sticky-option]').forEach((select) => {
        const controls = this.optionControls(select.dataset.stickyOption);
        const selected = controls.find((control) => control.tagName === 'SELECT' || control.checked);
        if (selected) select.value = selected.value;
        Array.from(select.options).forEach((option) => {
          const radio = controls.find((control) => control.type === 'radio' && control.value === option.value);
          if (radio) option.disabled = radio.disabled;
        });
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.section?.removeEventListener('change', this.onChange);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      window.removeEventListener('pageshow', this.schedule);
      cancelAnimationFrame(this.frame);
      this.intersection?.disconnect();
      this.mutations?.disconnect();
      this.resize?.disconnect();
      document.documentElement.style.removeProperty('--height-sticky');
    }
  });
}
